import { createContext, useState } from "react";

export const PopupContext = createContext({
  isPopupOpen: false,
  setIsPopupOpen: () => {},

  popupObject: [],
  setcheckIfpopupOpen: () => {},

  addItemToPopup: () => {},
});

export const PopUpStateProvider = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupObject, setcheckIfpopupOpen] = useState(false);

  const addItemToPopup = (productToAdd) => {
    setcheckIfpopupOpen(productToAdd);
  };

  const value = {
    isPopupOpen,
    setIsPopupOpen,
    addItemToPopup,
    popupObject,
  };

  return (
    <PopupContext.Provider value={value}>{children}</PopupContext.Provider>
  );
};
